import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Kaishutsuki = props => {
  return <Dropdown.Static kubunKey='kaishutsuki' {...props} />
}
